var _circle, _path, _circle2, _circle3, _rect, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4998,
    cy: 37.5,
    r: 36.5,
    fill: "#923094",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9692 66.7498C69.5241 59.8768 75.0001 49.3279 75.0001 37.5C75.0001 16.7893 58.2107 0 37.5001 0C28.0939 0 19.4965 3.46316 12.9136 9.18397L60.9692 66.7498Z",
    fill: "#A859A9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4998,
    cy: 37.5,
    r: 36,
    stroke: "white",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4998,
    cy: 37.5,
    r: 20,
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.9998,
    y: 21,
    width: 6,
    height: 22,
    fill: "#923094"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9998,
    cy: 50,
    r: 3,
    fill: "#923094"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNDk5OCIgY3k9IjM3LjUiIHI9IjM2LjUiIGZpbGw9IiM5MjMwOTQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYwLjk2OTIgNjYuNzQ5OEM2OS41MjQxIDU5Ljg3NjggNzUuMDAwMSA0OS4zMjc5IDc1LjAwMDEgMzcuNUM3NS4wMDAxIDE2Ljc4OTMgNTguMjEwNyAwIDM3LjUwMDEgMEMyOC4wOTM5IDAgMTkuNDk2NSAzLjQ2MzE2IDEyLjkxMzYgOS4xODM5N0w2MC45NjkyIDY2Ljc0OThaIiBmaWxsPSIjQTg1OUE5Ii8+CjxjaXJjbGUgY3g9IjM3LjQ5OTgiIGN5PSIzNy41IiByPSIzNiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxjaXJjbGUgY3g9IjM3LjQ5OTgiIGN5PSIzNy41IiByPSIyMCIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIvPgo8cmVjdCB4PSIzNC45OTk4IiB5PSIyMSIgd2lkdGg9IjYiIGhlaWdodD0iMjIiIGZpbGw9IiM5MjMwOTQiLz4KPGNpcmNsZSBjeD0iMzcuOTk5OCIgY3k9IjUwIiByPSIzIiBmaWxsPSIjOTIzMDk0Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };